export * from './icon.component';
export * as schema from './icon.schema';
export * as helpers from './icon.helpers';
